import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns/addDays";
import { subDays } from "date-fns/subDays";
import "./AppDatePicker.css";

interface RangeDatePickerProps {
  onChange: (dates: [Date | null, Date | null]) => void;
  minDaysSub: number;
  maxDaysAdd: number;
  defaultStartDate?: number;
  defaultEndDate?: number;
}

const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
  onChange,
  minDaysSub,
  maxDaysAdd,
}) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    onChange(dates);
  };

  return (
    <DatePicker
      selectsRange
      dateFormat="dd/MM/yyyy"
      startDate={startDate}
      endDate={endDate}
      onChange={handleDateChange}
      isClearable
      minDate={subDays(new Date(), minDaysSub)}
      maxDate={addDays(new Date(), maxDaysAdd)} // future enable
      placeholderText="Select Expiry Date"
      locale="en-GB"
      className="mr-1 px-4 py-2 border rounded pr-6 border-gray-300"
    />
  );
};

export default RangeDatePicker;